<template>
	<label :class="['text-counter', { 'text-counter--textarea': useTextarea }]">
		<textarea
			v-if="useTextarea"
			ref="input"
			:value="value"
			:maxlength="parseMaxLength"
			:placeholder="placeholder"
			:rows="rows"
			:required="required"
			:class="[
				'text-counter__textarea',
				{ 'text-counter__textarea-reply': textCounterType === 'reply' },
			]"
			@input="onInput"
			@keydown.enter="onEnter"
		/>
		<input
			v-else
			ref="input"
			:value="value"
			:maxlength="parseMaxLength"
			:placeholder="placeholder"
			:required="required"
			type="text"
			class="text-counter__input"
			@input="onInput"
		/>
		<span>
			[{{ count }} /
			<strong class="text-counter__max-length">{{ maxLength }}</strong
			>]
		</span>
	</label>
</template>
<script>
	export default {
		name: 'TextCounter',
		props: {
			value: {
				type: String,
				default: '',
			},
			maxLength: {
				type: Number,
				required: true,
			},
			useComma: {
				type: Boolean,
				default: false,
			},
			placeholder: {
				type: String,
				default: '',
			},
			useTextarea: {
				type: Boolean,
				default: false,
			},
			rows: {
				type: Number,
				default: null,
			},
			useLineLimit: {
				type: Boolean,
				default: false,
			},
			required: {
				type: Boolean,
				default: false,
			},
			lengthExceptSpacing: {
				type: Boolean,
				default: false,
			},
			textCounterType: {
				type: String,
				default: '',
			},
		},
		computed: {
			parseMaxLength() {
				return this.useComma || this.lengthExceptSpacing
					? false
					: this.maxLength;
			},
			count() {
				return this.getCount(this.value);
			},
		},
		methods: {
			getCount(value) {
				if (!value) return 0;
				if (this.useComma) value = value.replace(/,/gi, '');
				if (this.lengthExceptSpacing) value = value.replace(/\s/g, '');
				return value.length;
			},
			onInput(e) {
				const value = e.target.value;
				const maxLength = this.maxLength;
				if (maxLength >= this.getCount(value)) {
					e.target.value = value;
					this.$emit('input', value);
				} else {
					let length = maxLength;
					if (this.useComma) {
						length += (value.match(/,/gi, '') || []).length;
					}
					if (this.lengthExceptSpacing) {
						length += (value.match(/\s/g, '') || []).length;
					}
					const nv = value.substring(0, length);
					e.target.value = nv;
					this.$emit('input', nv);
				}
			},
			onEnter(e) {
				const curLine = (e.target.value.match(/\n/g) || []).length + 1;
				if (this.useLineLimit && curLine >= e.target.rows) {
					e.preventDefault();
					return false;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.text-counter {
		display: flex;
		align-items: center;
		white-space: nowrap;
		color: #222;
		font-size: 0.875rem;
		font-weight: 400;

		&--textarea {
			display: block;
			width: 100%;
			text-align: right;
		}

		&__textarea-reply {
			height: 300px;
			display: flex;
		}

		&__textarea {
			width: 100%;
		}

		&__input {
			display: block;
			margin-right: 8px;
		}

		&__max-length {
			font-weight: 700;
		}
	}
</style>
